/**
 * Utility functions for persisting RangeList column customization in localStorage
 */

const STORAGE_KEY_PREFIX = 'rangelist_columns_';

/**
 * Get the storage key for a specific RangeList
 */
function getStorageKey(globalId: string): string {
   return `${STORAGE_KEY_PREFIX}${globalId}`;
}

/**
 * Save customized columns to localStorage
 */
export function saveCustomColumns(globalId: string, columnIds: string[]): void {
   try {
      const key = getStorageKey(globalId);
      localStorage.setItem(key, JSON.stringify(columnIds));
   } catch (error) {
      console.error('Failed to save custom columns:', error);
   }
}

/**
 * Load customized columns from localStorage
 * Returns null if no customization exists
 */
export function loadCustomColumns(globalId: string): string[] | null {
   try {
      const key = getStorageKey(globalId);
      const stored = localStorage.getItem(key);
      if (stored) {
         return JSON.parse(stored);
      }
      return null;
   } catch (error) {
      console.error('Failed to load custom columns:', error);
      return null;
   }
}

/**
 * Clear customized columns from localStorage
 */
export function clearCustomColumns(globalId: string): void {
   try {
      const key = getStorageKey(globalId);
      localStorage.removeItem(key);
   } catch (error) {
      console.error('Failed to clear custom columns:', error);
   }
}

/**
 * Check if custom columns exist for a RangeList
 */
export function hasCustomColumns(globalId: string): boolean {
   try {
      const key = getStorageKey(globalId);
      return localStorage.getItem(key) !== null;
   } catch (error) {
      console.error('Failed to check custom columns:', error);
      return false;
   }
}
